// extracted by mini-css-extract-plugin
export default {"category":"css-6H9fNJmmZA","category__embed":"css-1WzTKlFWB3"};